import { getBooleanSchema, getStringSchema, getNumberSchema } from 'src/compass/shared/schemas';
import * as Yup from 'yup';

export const CMEAdditionalClearingSchema = Yup.object().shape({
  description: getStringSchema(50, 'Description').nullable(),
  isActive: getBooleanSchema('Active', true),
  asOf: Yup.object({
    amount: getNumberSchema('Amount'),
  }),
});
